import { Link, useParams } from "react-router-dom";
import MainFooter from "../../module/footer/main_footer";
import SubNavBar from "../../module/nav_bar/sub_nav_bar";
import "./service_page.css";
import DefinePage from "./define_page";
import DetailPage from "./detail_page";
import MatchingPage from "./matching_page";
import FixedBtn from "../../module/fixed_btn/fixed_btn";

function ServicePage() {
  const { contents } = useParams();
  let content, title;
  if (contents === "define") {
    content = <DefinePage />;
    title = "방문요양이란";
  } else if (contents === "detail") {
    content = <DetailPage />;
    title = "서비스 내용";
  } else if (contents === "matching") {
    content = <MatchingPage />;
    title = "요양사 매칭";
  }

  return (
    <div className="service_page">
      <nav>
        <SubNavBar />
      </nav>
      <div className="page_header">
        <div className="page_title">{title}</div>
        <ul className="sub_nav" id="service">
          <Link
            to="/service/define"
            className="link_btn"
            id={contents === "define" ? "active" : ""}
          >
            <li>방문요양이란</li>
          </Link>
          <Link
            to="/service/detail"
            className="link_btn"
            id={contents === "detail" ? "active" : ""}
          >
            <li>서비스 내용</li>
          </Link>
          <Link
            to="/service/matching"
            className="link_btn"
            id={contents === "matching" ? "active" : ""}
          >
            <li>요양사 매칭</li>
          </Link>
        </ul>
      </div>
      <main className="service_main">{content}</main>
      <FixedBtn />
      <footer>
        <MainFooter />
      </footer>
    </div>
  );
}

export default ServicePage;
